// Auto-generated by scripts/generateFactionSkinConfig.mjs
// Do not edit manually.

// eslint-disable-next-line no-unused-vars
import {FACTIONS} from '../../../constants/factions';
// eslint-disable-next-line no-unused-vars
import {PLAYER_COLORS} from '../../colors';

export const FACTION_SKINS_WIZARDS = [{
  id: 'wizards_engineer',
  factionId: FACTIONS.WIZARDS,
  name: 'Чертежник Реальности',
  priceNumens: 19000,
  skinRank: 1,
  colors: [
    PLAYER_COLORS.SKY_BLUE,
  ]
}, {
  id: 'wizards_evil',
  factionId: FACTIONS.WIZARDS,
  name: 'Заклинатель Скверны',
  priceNumens: 75000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.VIOLET,
    PLAYER_COLORS.RED,
  ]
}, {
  id: 'wizards_gun',
  factionId: FACTIONS.WIZARDS,
  name: 'Аркебузир',
  priceNumens: 100000,
  skinRank: 3,
}, {
  id: 'wizards_gold_legacy',
  factionId: FACTIONS.WIZARDS,
  name: 'Чародей вершин',
  priceNumens: 120000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
  ],
  excludedFromChests: true
}, {
  id: 'wizards_ruby_legacy',
  factionId: FACTIONS.WIZARDS,
  name: 'Верховный архимаг',
  priceCrystals: 350,
  skinRank: 4,
  colors: [
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.RED,
  ],
  accentColor: PLAYER_COLORS.RED,
  excludedFromChests: true
}];
